import Com from '../detail';
import css from './index.module.scss';
import CrowdFundingPC from '@/components/CrowdFunding';
import { useGlobal } from '@/utils/useGlobal';
import { bundleData } from '@/data/crowdfunding/delta2max';
import { ACTIVITY_MAP } from '@/constants/delta2max';

export default function CrowdFunding({ productDetail, resProductCatagory, nowSysTime, supportData, crowdfundingTimeline }: any) {
    const { useRouter, useLang } = useGlobal();
    const { t } = useLang('delta2max');
    const { locale } = useRouter();
    const bundlesData = bundleData[locale] || bundleData.jp;
    const activityId = ACTIVITY_MAP[locale] || ACTIVITY_MAP.jp;
    const bannerData = {
        // 1.EFPic 2.Image
        swiperImgs: [
            `/media/delta2max/crowdfunding/pc/banner1.jpg`,
            `/media/delta2max/crowdfunding/pc/banner2.jpg`,
            `/media/delta2max/crowdfunding/pc/banner3.jpg`,
            `/media/delta2max/crowdfunding/pc/banner4.jpg`,
            `/media/delta2max/crowdfunding/pc/banner5.jpg`,
        ],
        webpUrl: '',
        subTitle: '',
        title: t('crowdfunding.header.title'),
        desc: t.rich('crowdfunding.header.desc', {
            dot: (text: string) => <span className="dot">{text}</span>,
        }),
        showTC: ['jp'].includes(locale), // 是否显示问号 T&C内容弹窗
        productKey: 'delta2max',
        showCountdown: true,
    };

    const shopifyBtnProps = {
        /// domain & token
        options: (() => {
            const map: any = {};
            return map[locale] || null;
        })(),
        // 购物车
        cartText: {
            title: t('crowdfunding.shopify_btn.title'),
            total: t('crowdfunding.shopify_btn.total'),
            empty: t('crowdfunding.shopify_btn.empty'),
            notice: t('crowdfunding.shopify_btn.notice'),
            button: t('crowdfunding.shopify_btn.button'),
        },
    };

    return (
        <div className={`d2x-crowdfunding ${css.d2xCrowdfunding}`}>
            <CrowdFundingPC
                productDetail={productDetail}
                resProductCatagory={resProductCatagory}
                nowSysTime={nowSysTime}
                crowdfundingTimeline={crowdfundingTimeline}
                shopifyBtnProps={shopifyBtnProps}
                bundlesData={bundlesData}
                supportData={supportData}
                bannerData={bannerData}
                activityId={activityId}
                Com={Com}
                needEmail={locale === 'jp'}
            />
            <style jsx global>
                {`
                    .product_naver {
                        display: none;
                    }
                `}
            </style>
        </div>
    );
}
